import { ContactUsConfig } from '@tenants/types';
import { LOCALE_EXP_COMMERCIAL_PATHS } from 'types/locales';

export const contactUsConfig: ContactUsConfig = {
  socialLinks: {
    facebookUrl: 'https://www.facebook.com/profile.php?id=100065096766753',
    linkedinUrl: 'https://www.linkedin.com/company/exp-commercial/',
    youtubeUrl: 'https://www.youtube.com/@eXpCommercial',
    instagramUrl: 'https://www.instagram.com/exp.commercial/',
  },
  title: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_TITLE,
  description: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_DESCRIPTION,
  notificationContent: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_NOTIFICATIONCONTENT,
  bottomContent: {
    title: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_BOTTOMCONTENT_TITLE,
    description: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_BOTTOMCONTENT_DESCRIPTION,
  },
};